import { useDispatch, useSelector } from "react-redux";
import XImage from "../../assets/images/svgs/cancel-svgrepo-com (2).png";
import {
  createAdmin,
  deleteAdmin,
  updateAdmin,
} from "../../features/admins/adminsSlice";
import { hideConfirmationModal } from "../../features/confirmationModal/ConfirmationModalSlice";
import {
  addControlledAdmins,
  removeControlledAdmins,
} from "../../features/controlledHierarchy/controlledHierarchySlice";
import {
  addControlledTournaments,
  removeControlledTournaments,
} from "../../features/controlledTournaments/controlledTournamentsSlice";
import { deleteRegionImage } from "../../features/images/regionImages/regionImagesSlice";
import { deleteTournamentImage } from "../../features/images/tournamentImages/tournamentImagesSlice";
import { deleteMultiPurposeImage } from "../../features/images/multiPurposeImages/multiPurposeImagesSlice";
import { deleteUserImage } from "../../features/images/userImages/userImagesSlice";
import { deletePlayerFromTable } from "../../features/players/playersSlice";
import {
  deleteRegion,
  updateRegion,
} from "../../features/regions/regionsSlice";
import {
  deleteIngest,
  fetchTableIngestStatus,
} from "../../features/resultLogIngestSlice/resultLogIngestSlice";
import { createTable, deleteTable } from "../../features/tables/tableSlice";
import {
  deleteTournament,
  updateTournament,
} from "../../features/tournaments/tournamentsSlice";
import { deleteSquad, updateSquad } from "../../features/squads/squadsSlice";
import { deleteUser, updateUser } from "../../features/users/usersSlice";
import {
  hideComment,
  deleteComment,
  dismissReports,
  restoreDeletedComment,
} from "../../features/tournamentCommentReports/tournamentCommentReportsSlice";
import {
  deleteCommentDirect,
  deleteAllUserComments,
  banUserFromCommenting,
} from "../../features/tournamentAllComments/tournamentAllCommentsSlice";
import Button from "../button/Button";
import TextWrapper from "../textWrapper/TextWrapper";
import styles from "./confirmationModal.module.css";

const ConfirmationModal = () => {
  const { isVisible, message, data, actionType } = useSelector(
    (state) => state.confirmationModal,
  );

  const dispatch = useDispatch();

  const closeModalHandler = () => {
    dispatch(hideConfirmationModal());
  };

  const confirmModalHandler = () => {
    switch (actionType) {
      case "deleteAdmin":
        dispatch(deleteAdmin(data));
        closeModalHandler();
        break;
      case "createAdmin":
        dispatch(createAdmin(data));
        closeModalHandler();
        break;
      case "updateAdmin":
        dispatch(updateAdmin(data));
        closeModalHandler();
        break;
      case "deleteTournamentImage":
        dispatch(deleteTournamentImage(data));
        closeModalHandler();
        break;
      case "deleteTournament":
        dispatch(deleteTournament(data));
        closeModalHandler();
        break;
      case "updateTournament":
        dispatch(updateTournament(data));
        closeModalHandler();
        break;
      case "deleteRegionImage":
        dispatch(deleteRegionImage(data));
        closeModalHandler();
        break;
      case "deleteUser":
        dispatch(deleteUser(data));
        closeModalHandler();
        break;
      case "deleteSquad":
        dispatch(deleteSquad(data));
        closeModalHandler();
        break;
      case "updateUser":
        dispatch(updateUser(data));
        closeModalHandler();
        break;
      case "updateSquad":
        dispatch(updateSquad(data));
        closeModalHandler();
        break;
      case "deleteUserImage":
        dispatch(deleteUserImage(data));
        closeModalHandler();
        break;
      case "deleteMultiPurposeImage":
        dispatch(deleteMultiPurposeImage(data));
        closeModalHandler();
        break;
      case "createTable":
        dispatch(createTable(data));
        closeModalHandler();
        break;
      case "addControlledAdmin":
        dispatch(addControlledAdmins(data));
        closeModalHandler();
        break;
      case "removeControlledAdmin":
        dispatch(removeControlledAdmins(data));
        closeModalHandler();
        break;
      case "updateRegion":
        dispatch(updateRegion(data));
        closeModalHandler();
        break;
      case "deleteRegion":
        dispatch(deleteRegion(data));
        closeModalHandler();
        break;
      case "addTournamentAdmins":
        dispatch(addControlledTournaments(data));
        closeModalHandler();
        break;
      case "removeTournamentAdmins":
        dispatch(removeControlledTournaments(data));
        closeModalHandler();
        break;
      case "deleteTable":
        dispatch(deleteTable(data));
        closeModalHandler();
        break;
      case "deletePlayerFromTable":
        dispatch(deletePlayerFromTable(data));
        closeModalHandler();
        break;
      case "deleteIngestFile":
        dispatch(deleteIngest(data)).unwrap();
        dispatch(fetchTableIngestStatus({ tableId: data.tableId }));
        closeModalHandler();
        break;
      case "hideComment":
        dispatch(hideComment(data));
        closeModalHandler();
        break;
      case "deleteComment":
        dispatch(deleteComment(data.commentId));
        closeModalHandler();
        break;
      case "dismissReports":
        dispatch(dismissReports({ commentId: data.commentId }));
        closeModalHandler();
        break;
      case "unhideComment":
        dispatch(hideComment(data));
        closeModalHandler();
        break;
      case "restoreComment":
        dispatch(restoreDeletedComment(data.commentId));
        closeModalHandler();
        break;
      case "deleteCommentDirect":
        dispatch(deleteCommentDirect(data.commentId));
        closeModalHandler();
        break;
      case "deleteAllUserComments":
        dispatch(
          deleteAllUserComments({
            userId: data.userId,
            tournamentId: data.tournamentId,
          }),
        );
        closeModalHandler();
        break;
      case "banUserFromCommenting":
        dispatch(
          banUserFromCommenting({
            userId: data.userId,
            tournamentId: data.tournamentId,
          }),
        );
        closeModalHandler();
        break;
      default:
        closeModalHandler();
    }
  };

  if (!isVisible) return null;

  return (
    <div className={styles.container}>
      <div className={styles.messageWrapper}>
        <div className={styles.closeWrapper}>
          <img
            src={XImage}
            alt="close"
            className={styles.ximage}
            onClick={closeModalHandler}
          />
        </div>
        <div className={styles.message}>
          <TextWrapper textStyle="textMid">{message}</TextWrapper>
        </div>
        <div className={styles.buttonContainer}>
          <Button
            variant="greenVariant"
            size="midSize"
            functionallity={confirmModalHandler}
          >
            <TextWrapper textStyle="textMid">تأكيد الأمر</TextWrapper>
          </Button>
          <Button
            variant="redVariant"
            size="midSize"
            functionallity={closeModalHandler}
          >
            <TextWrapper textStyle="textMid">الغاء الامر</TextWrapper>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationModal;
